import { CorrectionType } from '@mews-commander/data-access';
import { TextKey } from '@mews-commander/enums';
import { Body } from '@optimus-web/core';
import { UnicodeEntity } from '@mews/enums';
import { LocalizedEnum } from '@mews/framework';
import { SidePanelInfoRowItem } from '../SidePanelInfoRowItem';

interface OwnProps {
    correctionType?: CorrectionType | null;
}

export const CorrectionBillCorrectionType = ({ correctionType }: OwnProps) => (
    <SidePanelInfoRowItem
        rowLabelTextKey={TextKey.CorrectionType}
        rowInfo={
            <Body>
                {correctionType ? <LocalizedEnum prefix="CorrectionType" value={correctionType} /> : UnicodeEntity.Dash}
            </Body>
        }
    />
);
